// extracted by mini-css-extract-plugin
module.exports = {"privacy":"Privacy_privacy__wlel-","contact-link":"Privacy_contact-link__2Hl8i","dates":"Privacy_dates__zAVTE","watch-tac-btn":"Privacy_watch-tac-btn__38FOa"};